import { render, staticRenderFns } from "./DesempenhoPedagogicoAlunoPage.vue?vue&type=template&id=b8166b0c&scoped=true"
import script from "./DesempenhoPedagogicoAlunoPage.vue?vue&type=script&lang=js"
export * from "./DesempenhoPedagogicoAlunoPage.vue?vue&type=script&lang=js"
import style0 from "./DesempenhoPedagogicoAlunoPage.vue?vue&type=style&index=0&id=b8166b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8166b0c",
  null
  
)

export default component.exports